import { useState } from "react";
import { ChangeAlertCallbackType } from "../../../Root";
import { useCRMFunction } from "./useCRMFunction";

import moment from "moment";
moment.locale("es");

export const useCRMDeals = (changeAlert: ChangeAlertCallbackType, form, getData, getRevenue) => {
    const { onHandleChangeStatus } = useCRMFunction(changeAlert);

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    const agent = localStorage.session ? JSON.parse(localStorage.session) : {};

    const onChangeStatus = async (tabActive, item, status) => {
        setLoading(true);
        const resp = await onHandleChangeStatus( tabActive, "low_funnel", status, item, agent );
        resp
            ? getRevenue() && getData(1, 30, form, tabActive)
            : setLoading(false);
    };

    return {
        data,
        loading,
        setData,
        onChangeStatus,
    };
};
